export const SECTION_IDS = {
  about: 'about',
  forWhom: 'forWhom',
  steps: 'steps',
  services: 'services',
  cases: 'cases',
};
